var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.impersonating)?_c('div',{attrs:{"id":"topbar"}},[_vm._v("\n    Viewing information for team\n    "),_c('b',[_vm._v(_vm._s(_vm.team.name))]),_vm._v(" "),_c('button',{on:{"click":_vm.switchBack}},[_vm._v("switch back")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59e17e1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/TopBar.vue
// module id = 5Vav
// module chunks = 1